import React from 'react'; 
import MovieTimesPeriodeDaysItems from './MovieTimesPeriodeDaysItems';
import getPerformancesIntervall from '../functions/getPerformancesIntervall';
import Translation from '../General/Translation';
import getTranslationTime from '../functions/getTranslationTime';
import getDayKey from '../functions/getDayKey';
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';
import { FRONT, TRANSLATION } from '../constants/state';
import getData from '../functions/getData';

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    translation: getData(state, TRANSLATION)
})

const MovieTimesPeriodeDays = ({
    movieId, 
    movieTitle, 
    translation, 
    performances, 
    onClick, 
    today, 
    currentDateActive, 
    activePerformance, 
    alternativeLinks,
    isMobile, 
    scrollToPosition, 
    cinemaDataFront,
    onOpenIframe, 
    toggleShowtimes
}) => {
    const { timezone } = translation
    const {show_performancePrice} = cinemaDataFront
    const keyToday = getDayKey(today)
    const periodesDays = getPerformancesIntervall(performances, today, timezone)

    const firstPerformanceDateWithPerformances = _.findKey(periodesDays, (periodeDay) => {
        if(!periodeDay) {
            return
        }
        const hasPerformance = periodeDay.length > 0
        return hasPerformance
    })

    if(_.size(periodesDays) > 10) {
        _.keys(periodesDays).map((pDayKey => {
            if (_.isEmpty(periodesDays[pDayKey])) {
                delete periodesDays[pDayKey];
            }
        }))
    }

    return _.keys(periodesDays).map((pDayKey, index) => {
        const periodeDay = periodesDays[pDayKey]
        if(!periodeDay) {
            return ''
        }

        const hasPerformance = periodeDay.length > 0
        const isToday = keyToday === pDayKey
        const dayFormarted= isToday ? <Translation id="today" trans={translation}>Heute</Translation> : getTranslationTime('performanceDates', translation, pDayKey)
        const todayBackgroundClass = isToday ? ' accent-color-background' : ' accent-color-background-dark'
        const todayClass = isToday ? ' today' : ''

        const activePeriodeDayOnMobile = () => {
            if(isMobile) {
                if(currentDateActive === '' && firstPerformanceDateWithPerformances === pDayKey) {
                    return ' active'
                } else if(currentDateActive !== '' && currentDateActive === pDayKey) {
                    return ' active'
                } else {
                    return ' not-visible'
                }
            } else {
                return ''
            }
        }    

        const renderedPerformances = <MovieTimesPeriodeDaysItems 
            movieId={movieId}
            movieTitle={movieTitle}
            performances={periodeDay} 
            toggleShowtimes={toggleShowtimes}
            showPerformancePrice={show_performancePrice}
            activePerformance={activePerformance}
            today={today} 
            alternativeLink={alternativeLinks}
            additionalClass={activePeriodeDayOnMobile()}
            translation={translation}
            isMobile={isMobile}
            scrollToPosition={scrollToPosition}
            onOpenIframe={onOpenIframe}
        />

        const performanceItems = hasPerformance ? renderedPerformances : ''
        let hasOngoingPerfomances = false

        
        for (var i = 0; i < periodeDay.length; i++) {
            if(periodeDay[i] != undefined) {
                hasOngoingPerfomances = true
            }
        }
        
        const additionalClasses = () => {
            if(!hasOngoingPerfomances && !isToday) {
               return ' display-none no-performances'
            } else if(!hasOngoingPerfomances && isToday) {
                return ' display-none'
            } else {
                return ''
            }
        }

        const dateButtonOverView = () => {
            if(isMobile) {
                return <button className={"date text-light" + todayBackgroundClass} onClick={() => onClick(pDayKey)}>{dayFormarted}</button>
            } else {
                return <div className={"date text-light" + todayBackgroundClass}>{dayFormarted}</div>
            }
        }
        
        return (
            <div key={index} className={"movie-times-item triangle-right movie-times-item-" + index + additionalClasses() + activePeriodeDayOnMobile() + todayClass}>
                {dateButtonOverView()}
                <div className="showtime-container">
                    {performanceItems}
                </div>
            </div> 
        )
    })
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(MovieTimesPeriodeDays)